import './index.less';
import tplDanmakuSetting from './tempalate.art';
import { nameMap, isPlainObject, isMobile } from '../../common/Utils';

const displayArea = [
  {
    label: 'fullScreen',
    icon: 'vh-player-iconfont vh-player-fill-player-FullScreen',
    value: [0, 1]
  },
  {
    label: 'Upscreen',
    icon: 'vh-player-iconfont vh-player-fill-player-Upscreen',
    value: [0, 0.25]
  },
  {
    label: 'Upperhalfscreen',
    icon: 'vh-player-iconfont vh-player-fill-player-Upperhalfscreen',
    value: [0, 0.5]
  },
  {
    label: 'Bottomscreen',
    icon: 'vh-player-iconfont vh-player-fill-player-Bottomscreen',
    value: [0.5, 1]
  }
];

const h5FontSizeArr = [
  {
    fontSize: 20,
    label: 'large'
  },
  {
    fontSize: 16,
    label: 'middle'
  },
  {
    fontSize: 12,
    label: 'small'
  }
];

const fontSizeArr = [
  {
    fontSize: 20,
    label: 'large'
  },
  {
    fontSize: 16,
    label: 'middle'
  },
  {
    fontSize: 12,
    label: 'small'
  }
];

const colorArr = [
  {
    color: '#ffffff' // 白色
  },
  {
    color: '#fb2626' // 红色
  },
  {
    color: '#ffb201' // 黄色
  },
  {
    color: '#16c973' // 绿色
  },
  {
    color: '#3552ea' // 蓝色
  },
  {
    color: '#dc12d2' // 紫色
  }
];

const speedArr = [
  {
    speed: 20000,
    label: 'slow'
  },
  {
    speed: 10000,
    label: 'standard'
  },
  {
    speed: 5000,
    label: 'fast'
  }
];

const defaultOptions = {
  color: '#ffffff',
  positionRange: [0, 0.5],
  opacity: 100,
  fontSize: 16,
  speed: 10000
};
export default class DanmakuSetting {
  /**
   * 构造函数
   * @param {Element} container 弹幕设置UI需要挂载的父容器
   * @param {Object} vhplayerInterface 包含弹幕相关参数
   */
  constructor(container, vhplayerInterface) {
    let popupContainer;
    if (vhplayerInterface.barrageSetting.popupContainer) {
      popupContainer = document.querySelector(vhplayerInterface.barrageSetting.popupContainer);
    }

    // 自定义弹幕设置面板容器优先级高于默认容器
    if (popupContainer) {
      // 初始显示方式
      popupContainer.style.display = vhplayerInterface.barrageSetting.popupBlock ? 'block' : 'none';
      this.container = popupContainer;
    } else {
      this.container = container;
    }
    this.vhplayerInterface = vhplayerInterface;
    this.Lang = vhplayerInterface.language;
    this.init();

    this.vhplayerInterface.__UIControl.updateBarrageUI = this.updateBarrageUI.bind(this);

    // 初始化时同步一次弹幕设置UI
    this.updateBarrageUI(vhplayerInterface.barrageSetting);
  }

  init() {
    // 初始化UI
    this._initView();
    // 初始化事件
    this._initEvents();
  }

  // 初始化弹幕设置UI界面
  _initView() {
    const options = Object.assign({}, defaultOptions, {
      isLight: this.vhplayerInterface.barrageSetting.popupStyle?.isLight || false,
      positionRange: this.vhplayerInterface.barrageSetting.positionRange,
      opacity: this.vhplayerInterface.barrageSetting.style.opacity,
      fontSize: isMobile()
        ? this.vhplayerInterface.barrageSetting.style.h5FontSize
        : this.vhplayerInterface.barrageSetting.style.fontSize,
      color: this.vhplayerInterface.barrageSetting.style.color,
      speed: this.vhplayerInterface.barrageSetting.speed
    });
    if (options.isLight) {
      colorArr[0].color = '#000000';
    }
    console.log('options:', options);
    const content = tplDanmakuSetting({
      options,
      displayArea: displayArea,
      fontSizeArr: isMobile() ? h5FontSizeArr : fontSizeArr, //移动端和pc端文字大小范围不一样
      colorArr: colorArr, // 弹幕颜色
      speedArr: speedArr,
      tran: key => this.Lang['barrage'][key]
    });

    this.container.insertAdjacentHTML('afterbegin', content);

    const danmakuSettingDom = this.container.querySelector('.vhplayer-danmaku-setting');
    if (danmakuSettingDom) {
      // 修改弹幕设置面板的主题色
      danmakuSettingDom.style.setProperty(
        '--danmaku-popup-theme-color',
        this.vhplayerInterface.barrageSetting.popupStyle.themeColor
      );
    }

    // 选择弹幕区域元素
    this.displayAreaItem = document.querySelectorAll('.vhplayer-danmaku-setting__display-area__item');

    // 透密度相关DOM
    this.opacityBar = document.querySelector('.vhplayer-danmaku-setting__opaticy');
    this.opacityBarInner = document.querySelector('.vhplayer-danmaku-setting__opaticy-slider__bar');
    this.opacityBarButton = document.querySelector('.vhplayer-danmaku-setting__opaticy-slider__button-wrapper');
    this.opacityBarLabel = document.querySelector('.vhplayer-danmaku-setting__opaticy-label');

    // 字体大小相关DOM
    this.fontSizeItem = document.querySelectorAll('.vhplayer-danmaku-setting__font__item');

    // 颜色块相关DOM
    this.colorItems = document.querySelectorAll('.vhplayer-danmaku-setting__color__item');

    // 弹幕速度相关DOM
    this.speedItems = document.querySelectorAll('.vhplayer-danmaku-setting__speed__item');
  }

  /**
   * 初始化弹幕设置相关事件
   */
  _initEvents() {
    this._initDisplayAreaEvents();
    this._initOpacityEvents();
    this._initFontSizeEvents();
    this._initColorEvents();
    this._initSpeedEvents();
  }

  /**
   * 初始化弹幕区域监听事件
   */
  _initDisplayAreaEvents() {
    Array.from(this.displayAreaItem).forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          return;
        }

        Array.from(this.displayAreaItem).forEach(el => el.classList.remove('active'));

        item.classList.add('active');

        const positionRange = item.dataset.value.split(',').map(item => Number(item));
        this.vhplayerInterface.barrageSetting.positionRange = positionRange;
        this._setBarrageInfo();
      });
    });
  }
  /**
   * 初始化透明度DOM监听事件
   */
  _initOpacityEvents() {
    // 获取透明度值，设置DOM
    const setOpaticy = event => {
      const e = event || window.event;
      const { width: opacityBarWidth, left: opacityBarLeft } = this.opacityBar.getBoundingClientRect();
      let percentage = (((e.clientX || e.changedTouches[0].clientX) - opacityBarLeft) / opacityBarWidth) * 100;
      percentage = percentage < 0 ? 0 : percentage > 100 ? 100 : percentage;
      percentage = parseInt(percentage);

      // 对DOM内容赋值
      this.opacityBarInner.style.width = `${percentage}%`;
      this.opacityBarButton.style.left = `${percentage}%`;
      this.opacityBarLabel.innerText = `${percentage}%`;

      this.vhplayerInterface.barrageSetting.style.opacity = percentage;

      this._setBarrageInfo();
    };

    const opacityMove = event => {
      setOpaticy(event);
    };
    const opacityUp = () => {
      document.removeEventListener(nameMap.dragEnd, opacityUp);
      document.removeEventListener(nameMap.dragMove, opacityMove);
    };
    this.opacityBar.addEventListener(nameMap.dragStart, () => {
      document.addEventListener(nameMap.dragMove, opacityMove);
      document.addEventListener(nameMap.dragEnd, opacityUp);
    });

    this.opacityBar.addEventListener('click', event => {
      setOpaticy(event);
    });
  }
  /**
   * 初始化字体大小DOM监听事件
   */
  _initFontSizeEvents() {
    Array.from(this.fontSizeItem).forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          return;
        }

        Array.from(this.fontSizeItem).forEach(el => el.classList.remove('active'));

        item.classList.add('active');

        const fontSize = Number(item.dataset.fontSize);
        if (isMobile()) {
          this.vhplayerInterface.barrageSetting.style.h5FontSize = fontSize;
        } else {
          this.vhplayerInterface.barrageSetting.style.fontSize = fontSize;
        }

        this._setBarrageInfo();
      });
    });
  }

  /**
   * 初始化颜色DOM监听事件
   */
  _initColorEvents() {
    Array.from(this.colorItems).forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          return;
        }

        Array.from(this.colorItems).forEach(el => el.classList.remove('active'));

        item.classList.add('active');

        this.vhplayerInterface.barrageSetting.style.color = item.dataset.color;

        this._setBarrageInfo();
      });
    });
  }

  _setBarrageInfo() {
    this.vhplayerInterface.setBarrageInfo({
      positionRange: this.vhplayerInterface.barrageSetting.positionRange,
      speed: this.vhplayerInterface.barrageSetting.speed,
      style: {
        fontSize: this.vhplayerInterface.barrageSetting.style.fontSize,
        opacity: this.vhplayerInterface.barrageSetting.style.opacity,
        color: this.vhplayerInterface.barrageSetting.style.color
      }
    });
  }
  /**
   * 初始化弹幕速度DOM监听事件
   */
  _initSpeedEvents() {
    Array.from(this.speedItems).forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          return;
        }

        Array.from(this.speedItems).forEach(el => el.classList.remove('active'));

        item.classList.add('active');

        const speed = Number(item.dataset.speed);
        this.vhplayerInterface.barrageSetting.speed = speed;

        this._setBarrageInfo();
      });
    });
  }

  /**
   * 根据弹幕设置参数更新弹幕设置UI表现
   * @param {Object} barrageSetting
   * @returns
   */
  updateBarrageUI(barrageSetting) {
    if (!isPlainObject(barrageSetting)) return;

    // 弹幕开关表现
    if (typeof barrageSetting.enable === 'boolean') {
      let brarageBtn = document.querySelector('.vhallPlayer-brarage-btn');
      if (!brarageBtn) {
        brarageBtn = document.querySelector('.h5vhallPlayer-brarage-btn');
      }
      if (brarageBtn) {
        if (barrageSetting.enable) {
          // 开启弹幕
          brarageBtn.classList.remove('vh-player-line-player-barrageoff');
          brarageBtn.classList.add('vh-player-line-player-barrageon');
        } else {
          // 关闭弹幕
          brarageBtn.classList.remove('vh-player-line-player-barrageon');
          brarageBtn.classList.add('vh-player-line-player-barrageoff');
        }
      }
    }

    // h5端弹幕开启/关闭横屏状态设置按钮UI同步
    const brarageBtnLandscape = document.querySelector('.h5vhallPlayer-brarage-component-Landscape');
    if (brarageBtnLandscape) {
      // 目前定的规则是竖屏状态不显示设置按钮，横屏状态根据开关状态显示设置按钮
      if (window.orientation == 180 || window.orientation == 0) {
        // 竖屏状态
        brarageBtnLandscape.style.display = 'none';
      }
      if (window.orientation == 90 || window.orientation == -90) {
        // 横屏状态
        brarageBtnLandscape.style.display = barrageSetting.enable ? 'block' : 'none';
      }
    }

    // 弹幕显示区域设置UI同步
    if (barrageSetting.positionRange) {
      Array.from(this.displayAreaItem).forEach(item => {
        if (item.dataset.value == barrageSetting.positionRange.join(',')) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    // 弹幕透明度设置UI同步
    const opacity = barrageSetting.style?.opacity;
    if (typeof opacity === 'number') {
      this.opacityBarInner.style.width = `${opacity}%`;
      this.opacityBarButton.style.left = `${opacity}%`;
      this.opacityBarLabel.innerText = `${opacity}%`;
    }

    // 弹幕字体大小设置UI同步
    const fontSize = isMobile() ? barrageSetting.style?.h5FontSize : barrageSetting.style?.fontSize;
    if (typeof fontSize === 'number') {
      Array.from(this.fontSizeItem).forEach(item => {
        if (item.dataset.fontSize == fontSize) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    // 颜色设置
    const color = barrageSetting.style?.color;
    if (color) {
      Array.from(this.colorItems).forEach(item => {
        if (item.dataset.color == color) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    // 弹幕速度设置UI同步
    if (barrageSetting.speed) {
      Array.from(this.speedItems).forEach(item => {
        if (item.dataset.speed == barrageSetting.speed) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }
  }
}
